import * as React from 'react';
import NAVector from 'assets/images/na-perdiem-vector.svg';
import axios from 'axios';
import { MessageCard } from './MessageCard';

interface Props {
  className?: string;
  error: unknown;
}

export const Error: React.FC<Props> = (props) => {
  const { className, error } = props;

  let title = 'Error';
  let description = 'There was an error loading the data.';

  if (axios.isAxiosError(error)) {
    if (error.response?.data?.error) {
      description = error.response.data.error;
      title = 'Not yet available for this port';
    }
  }

  return (
    <MessageCard
      className={className}
      iconography={<img src={NAVector} alt="Empty State" />}
      title={title}
      description={description}
    />
  );
};
Error.displayName = 'Shipments.DetailDrawer.Sections.PerDiem.Error';
